interface OfferStage {
  status: string
  label: string
  activeClass: string
  inactiveClass: string
}

const OFFER_STAGES: OfferStage[] = [
  {
    status: 'PENDING',
    label: 'Pending',
    activeClass: 'bg-yellow-600 text-white',
    inactiveClass: 'bg-yellow-50 text-yellow-700 hover:bg-yellow-100',
  },
  {
    status: 'VIEWED',
    label: 'Viewed',
    activeClass: 'bg-blue-600 text-white',
    inactiveClass: 'bg-blue-50 text-blue-700 hover:bg-blue-100',
  },
  {
    status: 'ACCEPTED',
    label: 'Accepted',
    activeClass: 'bg-green-600 text-white',
    inactiveClass: 'bg-green-50 text-green-700 hover:bg-green-100',
  },
  {
    status: 'REJECTED',
    label: 'Rejected',
    activeClass: 'bg-red-600 text-white',
    inactiveClass: 'bg-red-50 text-red-700 hover:bg-red-100',
  },
  {
    status: 'WITHDRAWN',
    label: 'Withdrawn',
    activeClass: 'bg-gray-600 text-white',
    inactiveClass: 'bg-gray-50 text-gray-600 hover:bg-gray-100',
  },
  {
    status: 'EXPIRED',
    label: 'Expired',
    activeClass: 'bg-orange-600 text-white',
    inactiveClass: 'bg-orange-50 text-orange-700 hover:bg-orange-100',
  },
]

interface ProspectPipelineStatsProps {
  activeOfferStatusFilter?: string
  onOfferStatusFilterChange: (offerStatus: string | undefined) => void
}

export default function ProspectPipelineStats({
  activeOfferStatusFilter,
  onOfferStatusFilterChange,
}: ProspectPipelineStatsProps) {
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <button
        onClick={() => onOfferStatusFilterChange(undefined)}
        className={`px-3 py-1.5 text-sm font-medium transition-colors ${
          activeOfferStatusFilter === undefined
            ? 'bg-gray-900 text-white'
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
      >
        All
      </button>

      {OFFER_STAGES.map(({ status, label, activeClass, inactiveClass }) => {
        const isActive = activeOfferStatusFilter === status
        return (
          <button
            key={status}
            onClick={() => onOfferStatusFilterChange(isActive ? undefined : status)}
            className={`px-3 py-1.5 text-sm font-medium transition-colors ${
              isActive ? activeClass : inactiveClass
            }`}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
